import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';

export function useAccess() {
  const featureKeys = useSelector((state: RootState) => state.auth.featureKeys);
  const operationsLocked = useSelector(
    (state: RootState) => state.auth.operationsLocked,
  );

  const can = useCallback(
    (featureKey: string) => featureKeys.includes(featureKey),
    [featureKeys],
  );

  /** Feature check AND org is not payment-locked (for create/edit/delete/export). */
  const canMutate = useCallback(
    (featureKey?: string) => {
      if (operationsLocked) return false;
      if (featureKey) return featureKeys.includes(featureKey);
      return true;
    },
    [featureKeys, operationsLocked],
  );

  return { can, canMutate, featureKeys, operationsLocked };
}
